import React, { Component } from "react";
import Helmet from "react-helmet";
import ContactFind from "../components/Contact/ContactFind";
import config from "../../data/SiteConfig";
import Header from "../components/Header/Header";
import Clear from "../components/Structure/Clear";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import HeaderPage from "../components/Header/HeaderPage";
import Footer from "../components/Footer/Footer";
import picture from "./img/contact.jpg";
import Menu from "../components/Menu/Menu";

class Dm extends Component {
  render() {
    const { slug } = this.props.pathContext;

    let title = "Développeur mobile hybride (H/F)";
    let description = "React et React Native";
    let goto = "";

    const postNode = {
        "frontmatter": {
            "title": title,
            "description": "Rejoignez nos équipes de développement innovantes et dynamiques autour de nombreux projets mobiles passionnants avec des technologies actuelles!",
            "cover": picture
        }
    };

    return (
        <div className="contact">
            <Helmet title={title} />
            <SEO postPath={slug} postNode={postNode} postSEO />
            <Menu />
            <Header />
            <HeaderPage title={title} description={description} picture={picture} />
            <article className="container row-bottom-padded-md row-top-padded-md">
                <div className="col-md-12">

                    <h2>Qui sommes nous ?</h2>
                    <p>Integral Service est un studio Web rattaché à la société Integral System (2003) spécialisée dans la réalisation d'application Web et mobile sur-mesure.
                    </p>
                    <p>Nos derniers projets palpitants en date sont la création d'un jeu de simulation de gestion de société pour la société IPAJE, la création d'un site E-Commerce éphémère pour Michelin, la réalisation d'une application métier pour les 3000 infirmières du groupe Synlab Labco ou encore la réalisation d'un réseau social pour les compositeurs de musique, sans parler des portails pour Emmaüs</p>
                    <p>C'est dans ce cadre de croissance et d'intégration de nouvelles offres que nous recherchons un <strong>développeur mobile hybride</strong> pour rejoindre notre équipe de développement</p>
                    <h2>Mission</h2>
                    <p>Vous travaillez en collaboration avec les équipes de développement actuellement en place sur de nombreux sujets passionnants:</p>
                    <ul>
                        <li>Développements d'applications mobile hybride et Web Apps / <a href="/quest-ce-quune-progressive-web-app" title="Progressive web apps" target="_blank">Porgressive Web apps</a> en React et React Native'</li>
                        <li>Consommation d'API</li>
                        <li>Intégration et déploiement continue</li>
                        <li>Tests unitaires et fonctionnels</li>
                        <li>Discussions à propos de préconisations et solutions techniques</li>
                    </ul>
                    <p>le tout dans une ambiance d'entraide et partage de connaissance au sein des équipes, pour des projets internes ou projets client encore plus passionnant !</p>
                    <h2>Nos outils</h2>
                    <p>Slack est notre plateforme de communication, suivi des projets et de veille. Trello nous permet de suivre et piloter nos sprints projet (Scrum). 
                    </p><p>
                    Notre plateforme d’intégration continue utilise Docker, Jenkins, PHPUnit, Behat, … et est couplée avec Github et Gitlab pour la gestion du code source.
                    </p>
                    <p>
                    Le pair programming et la revue de code sont notre quotidien !
                    </p>
                    <h2>Profil</h2>
                    <ul>
                        <li>Issu d'une formation Bac+2 et plus en informatique</li>
                        <li>Une passion pour tout ce qui entoure le web et le mobile</li>
                        <li>Une expérience dans le développement mobile avec React Native</li>
                        <li>L'anglais lu et écrit est indispensable</li>
                        <li>Linux ne vous fait pas peur</li>
                    </ul>
<p>
Vous avez un super esprit d'équipe, un bon relationnel, vous êtes dynamique, savez travailler de façon autonome et êtes doté d'une bonne capacité d'écoute.
</p>
                    <h2>Les plus</h2>
                    <ul>
                        <li>Avoir déjà fait du backend</li>
                        <li>L'intégration et le déploiement continu n'est pas qu'un concept pour vous</li>
                    </ul>
                    <div className="col-md-12 p-3 d-flex justify-content-center">
                         <a  href="/contact" title="Postuler pour l'offre de développeur Symfony PHP"><button className="btn btn-primary">Postuler</button></a>
                    </div>
                    
                </div>
            </article>
            <Clear />
            <Footer />
        </div>
    );
  }
}

export default Dm;



// WEBPACK FOOTER //
// ./src/pages/developpeur-mobile-offre-emploi.jsx